import React from 'react'
import PropTypes from 'prop-types'
import { Badge, Button, Col } from 'reactstrap'
import { ButtonContainer, StyledRow } from './component.styles'
import EditSiteModal from '../EditSiteModal'
import SiteSummary from '../SiteSummary'
import SiteUsers from '../SiteUsers'

const Site = ({
  addBulkUsersResponse,
  backToSearch,
  createSiteUser,
  createSiteUsers,
  error,
  fetchLessonProgressReport,
  fetchTrainingReport,
  handleCancelUserAccess,
  handleGrantNewRole,
  isBulkOperationCompleted,
  isFetchingReports,
  remindSiteUser,
  remindSiteUsers,
  reports,
  resetBulkAddUsers,
  selectedSite,
  showEditModal,
  site,
  siteId,
  siteUsers,
  toggleEditModal,
}) => {
  const { netSuiteCustomer } = site || {}
  const { nsCustomerId } = netSuiteCustomer || {}

  return (
    <React.Fragment>
      <p>
        <Button color="primary" onClick={() => backToSearch(false)} outline>
          <i className="fas fa-chevron-left" />
          &nbsp; Back to Search
        </Button>
      </p>
      {site && (
        <div>
          <StyledRow>
            <Col>
              <h2 className="mt-2 text-light">
                Site&nbsp;
                <Badge color="light">SS: {site.id}</Badge>&nbsp;
                {!!nsCustomerId && (
                  <Badge color="light">NS: {nsCustomerId}</Badge>
                )}
              </h2>
            </Col>
            <Col>
              <ButtonContainer>
                <Button color="light" onClick={toggleEditModal}>
                  <i className="fas fa-pencil-alt" />
                  &nbsp;Edit
                </Button>
              </ButtonContainer>
              <h2 className="mt-2 text-light">
                {site.inactive && (
                  <Badge className="badge-warning">Inactive</Badge>
                )}
              </h2>
            </Col>
          </StyledRow>
          <SiteSummary
            fetchLessonProgressReport={fetchLessonProgressReport}
            fetchTrainingReport={fetchTrainingReport}
            isFetchingReports={isFetchingReports}
            reports={reports}
            site={site}
            siteUsers={siteUsers}
          />
          {siteUsers && (
            <SiteUsers
              handleCancelUserAccess={handleCancelUserAccess}
              handleGrantNewRole={handleGrantNewRole}
              site={site}
              addBulkUsersResponse={addBulkUsersResponse}
              error={error}
              isBulkOperationCompleted={isBulkOperationCompleted}
              siteUsers={siteUsers}
              siteId={siteId}
              createSiteUser={createSiteUser}
              createSiteUsers={createSiteUsers}
              remindSiteUser={remindSiteUser}
              remindSiteUsers={remindSiteUsers}
              resetBulkAddUsers={resetBulkAddUsers}
              selectedSite={selectedSite}
            />
          )}
        </div>
      )}
      {showEditModal && (
        <EditSiteModal
          isOpen={showEditModal}
          site={site}
          toggle={toggleEditModal}
        />
      )}
    </React.Fragment>
  )
}

Site.propTypes = {
  backToSearch: PropTypes.func.isRequired,
  fetchLessonProgressReport: PropTypes.func.isRequired,
  fetchTrainingReport: PropTypes.func.isRequired,
  handleCancelUserAccess: PropTypes.func.isRequired,
  handleGrantNewRole: PropTypes.func.isRequired,
  isFetchingReports: PropTypes.object.isRequired,
  remindSiteUser: PropTypes.func.isRequired,
  remindSiteUsers: PropTypes.func,
  reports: PropTypes.object,
  site: PropTypes.object,
  siteUsers: PropTypes.array,
  showEditModal: PropTypes.bool.isRequired,
  toggleEditModal: PropTypes.func.isRequired,
}

export default Site



// WEBPACK FOOTER //
// ./src/components/Site/component.js